module.exports = __webpack_public_path__ + "img/25_13.e64faf4f.png";